import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useStripeStore = defineStore('useStripeStore', () => {
  const stripeToken = ref<any | null>(null)
  const stripe = ref<any | null>(null)

  return { stripeToken, stripe }
})
